import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PopoverButton } from "@headlessui/vue";

import { Button } from "@/components/global";
import { DotsIcon } from "@/components/svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'Dots',
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const onDotsClick = (e: Event) => {
  e.stopPropagation();

  emit('click', e)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopoverButton), {
    onClick: _withModifiers(onDotsClick, ["stop"])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Button), _mergeProps(_ctx.$attrs, {
        variant: "naked",
        "test-id": "three-dots",
        class: "dots flex-center"
      }), {
        default: _withCtx(() => [
          _createVNode(_unref(DotsIcon), {
            width: "0.875rem",
            height: "0.5rem"
          })
        ]),
        _: 1
      }, 16)
    ]),
    _: 1
  }))
}
}

})